import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { store } from "./Redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from '@react-oauth/google';

const APP_CACHE_VERSION = "2026-04-02-theme-refresh-1";

const clearStaleBrowserCaches = async () => {
  try {
    const cacheKey = "app_cache_version";
    const currentVersion = localStorage.getItem(cacheKey);
    if (currentVersion === APP_CACHE_VERSION) return;

    // Force-remove stale SW registrations/caches (Safari can keep old bundles).
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    localStorage.setItem(cacheKey, APP_CACHE_VERSION);
  } catch (_error) {
    // Non-blocking: app should render even if cache cleanup fails.
  }
};

clearStaleBrowserCaches();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </BrowserRouter>
  </Provider>
  // {/* </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
